import { createContext } from 'react';
import type { OwnedTeam, MemberTeam } from '../api/teamApi';

export interface TeamWorkspaceOption {
  id: string;
  name: string;
  ownerName: string;
  isOwner: boolean;
}

export interface TeamContextValue {
  ownedTeam: OwnedTeam | null;
  memberTeams: MemberTeam[];
  /** Unified teams list (owned + joined) for selectors and guards. */
  userTeams: TeamWorkspaceOption[];
  /** Currently selected team object resolved from `activeTeamId`. */
  currentTeam: TeamWorkspaceOption | null;
  /** Team id sent as `X-Team-Id` for recipe APIs (owner or member workspace). */
  activeTeamId: string | null;
  setActiveTeamId: (id: string | null) => void;
  loading: boolean;
  refreshTeamContext: () => Promise<void>;
  /** Ensures active team is valid against latest memberships. */
  reconcileActiveTeam: (opts?: { redirectIfMissing?: boolean }) => void;
}

export const TeamContext = createContext<TeamContextValue | undefined>(
  undefined,
);
